<template>
  <el-dialog
    v-model="isDialogPayment"
    align-center
    :close-on-click-modal="false"
    @close="handleDialogClose"
    width="90%"
  >
    <template #header>
      <div class="fw-800">
        <div>Order ID: {{ items.data?.order_id || "Loading..." }}</div>
        <div>
          Username:
          <span
            class="c-pointer text-primary"
            @click="clickPushUser(items?.data.username)"
          >
            {{ items.data?.username }}
          </span>
          <span v-if="items.data?.nickname">({{ items.data?.nickname }})</span>
        </div>
      </div>
    </template>

    <div v-if="items?.data">
      <div style="display: flex">
        <div style="width: 50%">
          <div class="fw-500 fs-10">
            Amount:
            <span class="fw-800 fs-15 text-success">
              {{ formatCurrency(items?.data?.amount) }}
            </span>
          </div>
          <div
            class="mt-3"
            style="display: flex; color: #885200; justify-content: start"
          >
            <div class="mr-4">
              <SvgSprite
                name="custom-warning-fill"
                style="width: 50px; height: 50px"
              />
            </div>

            <div class="fw-800">
              <p>
                <v-avatar size="5" class="mr-2" color="#885200"></v-avatar>
                Please transfer the exact specified amount correctly.
              </p>
              <p>
                <v-avatar size="5" class="mr-2" color="#885200"></v-avatar>
                โปรดโอนเงินให้ตรงกับจำนวนที่ระบุไว้อย่างถูกต้อง
              </p>
              <p>
                <v-avatar size="5" class="mr-2" color="#885200"></v-avatar>
                请准确转账指定的金额。
              </p>
            </div>
          </div>

          <div class="mt-2">
            <v-card variant="outlined" elevation="0">
              <v-list class="p-8" style="background: transparent !important">
                <v-list-item>
                  <template v-slot:prepend>
                    <v-avatar variant="tonal" color="warning" rounded="md">
                      <SvgSprite
                        name="custom-clock-outline"
                        style="width: 20px; height: 20px"
                      />
                    </v-avatar>
                  </template>
                  <h6 class="text-subtitle-1 mb-0">
                    <p>
                      Expired At:
                      {{ formattedExpiredAt(items.data?.expired_at) }}
                    </p>
                    <p class="text-error">Time Left: {{ countdown }}</p>
                  </h6>
                </v-list-item>
              </v-list>
            </v-card>
          </div>

          <div class="mt-2">
            <v-card variant="outlined" elevation="0">
              <v-list class="p-8" style="background: transparent !important">
                <div class="fw-800">
                  <p>
                    <v-avatar
                      size="5"
                      class="mr-2"
                      color="secondary"
                    ></v-avatar>
                    Please upload the payment slip after the transfer is
                    successful.
                  </p>
                  <p>
                    <v-avatar
                      size="5"
                      class="mr-2"
                      color="secondary"
                    ></v-avatar>
                    กรุณาอัพโหลดสลิป หลังจากโอนสำเร็จ
                  </p>
                  <p>
                    <v-avatar
                      size="5"
                      class="mr-2"
                      color="secondary"
                    ></v-avatar>
                    请在转账成功后上传付款凭证。
                  </p>
                </div>
              </v-list>
            </v-card>
          </div>

          <div
            class="my-2"
            style="
              background: #00092d;
              padding: 10px;
              border: 2px solid #ffc200;
            "
          >
            <span style="color: #fff" class="fw-900">
              <span style="color: #92ff00"
                >PROVIDER: {{ items.data?.provider.toUpperCase() }} |
              </span>
              <span> STATUS : </span>
              <span v-if="items.data?.status === 0" class="text-warning">
                <SvgSprite
                  name="custom-clock-outline"
                  style="width: 20px; height: 20px"
                />
                Pending</span
              >
              <span v-else-if="items.data?.status === 1" class="text-success">
                <SvgSprite
                  name="custom-check-circle-fill"
                  style="width: 20px; height: 20px"
                />
                Success</span
              >
              <span v-else class="text-error">
                <SvgSprite
                  name="custom-close-circle-outline"
                  style="width: 20px; height: 20px"
                />
                Failed</span
              >
            </span>

            <!-- <span
              class="fw-800 ml-3 mr-1 px-2"
              style="background: red; color: #fff !important"
            >
              No Slip
            </span> -->

            <v-btn
              class="fw-800 ml-3"
              :color="items.data?.slip_url ? 'primary' : 'warning'"
              size="small"
              @click="handleUpload(items.data)"
            >
              {{ items.data?.slip_url ? "Change Slip" : "Upload Slip" }}
            </v-btn>
          </div>

          <div style="display: flex; justify-content: space-between">
            <v-btn
              class="fw-800 mr-4"
              color="error"
              @click="reportTransaction(items.data)"
            >
              Report Transaction
            </v-btn>

            <v-btn class="fw-800" color="info" @click="getDetail()">
              <SvgSprite
                name="custom-refresh-2"
                style="width: 20px; height: 20px"
              />

              Refresh
            </v-btn>
          </div>
        </div>

        <div style="width: 50%" class="px-5">
          <div class="mb-3">
            <p>
              {{ items.data?.note ? "Note : " + items.data?.note : "" }}
            </p>
            <p
              @click="getDetail(items.data?.link_order_id)"
              class="text-primary fw-800 c-pointer"
            >
              {{
                items.data?.link_order_id
                  ? "Link Order ID : " + items.data?.link_order_id
                  : ""
              }}
            </p>
          </div>

          <span
            v-if="!items.data?.slip_url"
            class="fw-800 ml-3 mr-1 px-2"
            style="background: red; color: #fff !important"
          >
            No Slip
          </span>

          <img
            v-if="items.data?.slip_url"
            :src="items.data?.slip_url"
            alt="Slip Image"
            style="width: 100%; height: auto"
          />
        </div>
      </div>

      <div class="mt-2">
        <a
          v-if="items.data?.provider?.toLowerCase() === 'opy' && items.data?.payment_url"
          class="opy-pay-btn"
          :href="items.data.payment_url"
          target="_blank"
          rel="noopener noreferrer"
        >
          <span class="opy-pay-btn__shine" aria-hidden="true"></span>
          <span class="opy-pay-btn__icon" aria-hidden="true">
            <svg viewBox="0 0 24 24" fill="none">
              <path
                d="M14 5h5v5M19 5l-9 9"
                stroke="currentColor"
                stroke-width="2.2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M19 13v5a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h5"
                stroke="currentColor"
                stroke-width="2.2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </span>
          <span class="opy-pay-btn__copy">
            <span class="opy-pay-btn__title">Open payment page</span>
            <span class="opy-pay-btn__sub">เปิดหน้าชำระเงินในแท็บใหม่</span>
          </span>
          <span class="opy-pay-btn__go" aria-hidden="true">เปิดเลย</span>
        </a>
        <iframe
          v-else
          :src="items.data?.payment_url"
          width="100%"
          height="500px"
          frameborder="0"
        ></iframe>
      </div>
    </div>
    <template #footer>
      <div class="dialog-footer">
        <el-button
          variant="flat"
          size="large"
          rounded="md"
          type="danger"
          @click="handleDialogClose"
          >Cancel</el-button
        >
      </div>
    </template>
  </el-dialog>

  <upload-slip
    v-model="isDialogVisibleUpload"
    :selectedOrder="selectedOrder"
    @submit-upload="handleUploadSubmit"
  />

  <upline-tree v-model="popupUplineTree" :selectUser="selectUser" />
</template>

<script lang="ts" setup>
import {
  defineProps,
  defineEmits,
  ref,
  inject,
  computed,
  onMounted,
  watch,
} from "vue";
import ApiService from "@/core/services/Transaction.ts";
import { LoadingService } from "@/core/plugins/loading";
import { ElNotification } from "element-plus";
import SvgSprite from "@/components/shared/SvgSprite.vue";
import { ElMessageBox } from "element-plus";

import UploadSlip from "@/views/sellstock/transaction/UploadSlip";
import UplineTree from "@/views/sellstock/downline/UplineTree";

const $loading = inject("$loading") as LoadingService;

const items = ref("");
const countdown = ref("");

const props = defineProps({
  modelValue: Boolean,
  selectedOrder: Object,
});

const emit = defineEmits();

const isDialogPayment = computed({
  get: () => props.modelValue,
  set: (value) => {
    emit("update:modelValue", value);
  },
});

const handleDialogClose = () => {
  items.value = "";
  emit("update:modelValue", false);
};

const openOpyPaymentPage = (data: any) => {
  if (data?.provider?.toLowerCase() !== "opy" || !data?.payment_url) return;

  const popup = window.open(data.payment_url, "_blank");
  if (popup) {
    popup.opener = null;
    return;
  }

  ElNotification({
    title: "Payment page",
    message: "Pop-up was blocked. Please click Open payment page.",
    type: "warning",
  });
};

const getDetail = async (id: any, autoOpenPayment = false) => {
  $loading.startLoading();
  if (!props.selectedOrder?.order_id) return;
  const resp = await ApiService.payDetail({
    order_id: id ? id : props.selectedOrder.order_id,
  });
  if (resp.status == "success") {
    ElNotification({
      title: resp.status,
      message: resp.msg,
      type: resp.status,
    });

    if (resp.data || resp.data != null || resp.data != undefined) {
      items.value = resp;
      updateCountdown();
      emit("update:modelValue", true);
      if (autoOpenPayment) {
        openOpyPaymentPage(resp.data);
      }
    }
  } else {
    ElNotification({
      title: "Error",
      message: resp.error || resp.msg,
      type: "error",
    });
    emit("update:modelValue", false);
  }
  $loading.endLoading();
};

const getChipColor = (status: string) => {
  if (status === 2) {
    return "error";
  } else if (status === 1) {
    return "success";
  } else if (status === 0) {
    return "secondary";
  } else {
    return "default";
  }
};

const isDialogVisibleUpload = ref(false);
const selectedOrder = ref("");

const showSlip = ref(false);

const closeUploadDialog = () => {
  isDialogVisibleUpload.value = false;
  selectedOrder.value = null;
};

const handleUpload = (item: any) => {
  isDialogVisibleUpload.value = true;
  selectedOrder.value = item;
};

const popupUplineTree = ref(false);
const selectUser = ref("");

const clickPushUser = (item: any) => {
  popupUplineTree.value = true;
  selectUser.value = item;
};

watch(
  () => popupUplineTree.value,
  (newVal) => {
    if (!newVal) {
      selectUser.value = "";
    }
  },
  { immediate: true }
);

const handleUploadSubmit = (data) => {
  getDetail();
  closeUploadDialog();
};

const formatDate = (dateStr: string) => {
  const date = new Date(dateStr);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const seconds = String(date.getSeconds()).padStart(2, "0");
  return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
};

const updateCountdown = () => {
  const expiryDate = new Date(items.value.data.expired_at);
  const interval = setInterval(() => {
    const now = new Date();
    const remainingTime = expiryDate.getTime() - now.getTime();

    if (remainingTime <= 0) {
      clearInterval(interval);
      countdown.value = "Expired";
    } else {
      const hours = Math.floor(remainingTime / (1000 * 60 * 60));
      const minutes = Math.floor(
        (remainingTime % (1000 * 60 * 60)) / (1000 * 60)
      );
      const seconds = Math.floor((remainingTime % (1000 * 60)) / 1000);
      countdown.value = `${hours}h ${minutes}m ${seconds}s`;
    }
  }, 1000);
};

const formattedExpiredAt = (expiredAt: string) => {
  return formatDate(expiredAt);
};

watch(
  () => props.selectedOrder,
  (newVal) => {
    if (newVal) {
      getDetail(undefined, true);
    }
  },
  { immediate: true }
);

const reportTransaction = async (data: any) => {
  try {
    await ElMessageBox.confirm(
      `Are you sure you want to report transaction ${data.order_id}?`,
      "Confirm Report",
      {
        confirmButtonText: "Confirm",
        cancelButtonText: "Cancel",
        type: "warning",
        cancelButtonClass: "bg-error",
      }
    );

    const resp = await ApiService.reportTransactionSubmit({
      order_id: data.order_id,
    });

    ElNotification({
      title: resp.status,
      message: resp.msg,
      type: resp.status,
    });
  } catch (error) {
    console.log("Cancelled or failed", error);
  }
};
const formatCurrency = (amount: number | null | undefined): string => {
  if (amount === null || amount === undefined) return "฿0.00";

  return new Intl.NumberFormat("th-TH", {
    style: "currency",
    currency: "THB",
    minimumFractionDigits: 2,
  }).format(amount);
};
</script>

<style>
.v-col-md-6,
.v-col-lg-6,
.v-col-6,
.v-col-md-12,
.v-col-lg-12,
.v-col-12 {
  padding: 3px 12px !important;
}

.opy-pay-btn {
  position: relative;
  display: flex;
  align-items: center;
  gap: 16px;
  width: 100%;
  min-height: 84px;
  margin-top: 4px;
  padding: 16px 18px 16px 16px;
  border: 2px solid #7a4d00;
  border-radius: 16px;
  background: linear-gradient(120deg, #ffe56a 0%, #ffc200 42%, #ffb000 100%);
  box-shadow:
    0 10px 28px rgba(255, 176, 0, 0.45),
    inset 0 1px 0 rgba(255, 255, 255, 0.7);
  color: #00092d;
  text-decoration: none;
  cursor: pointer;
  animation: opy-pay-pulse 1.8s ease-in-out infinite;
}

.opy-pay-btn__shine {
  position: absolute;
  inset: 0;
  overflow: hidden;
  border-radius: inherit;
  pointer-events: none;
}

.opy-pay-btn__shine::before {
  content: "";
  position: absolute;
  inset: 0;
  background: linear-gradient(
    105deg,
    transparent 32%,
    rgba(255, 255, 255, 0.72) 48%,
    transparent 64%
  );
  transform: translateX(-130%);
  animation: opy-pay-shimmer 2.6s ease-in-out infinite;
}

.opy-pay-btn:hover,
.opy-pay-btn:focus,
.opy-pay-btn:visited {
  color: #00092d;
  text-decoration: none;
}

.opy-pay-btn:hover {
  transform: translateY(-2px);
  animation: none;
  background: linear-gradient(120deg, #fff1a3 0%, #ffd23a 42%, #ffc200 100%);
  box-shadow:
    0 16px 34px rgba(255, 176, 0, 0.55),
    inset 0 1px 0 rgba(255, 255, 255, 0.85);
}

.opy-pay-btn:active {
  transform: translateY(0);
}

.opy-pay-btn:focus-visible {
  outline: 3px solid #00092d;
  outline-offset: 3px;
}

.opy-pay-btn__icon,
.opy-pay-btn__copy,
.opy-pay-btn__go {
  position: relative;
  z-index: 1;
}

.opy-pay-btn__icon {
  flex: 0 0 auto;
  display: grid;
  place-items: center;
  width: 52px;
  height: 52px;
  border-radius: 14px;
  background: #00092d;
  color: #ffc200;
  box-shadow: 0 6px 14px rgba(0, 9, 45, 0.28);
}

.opy-pay-btn__icon svg {
  width: 26px;
  height: 26px;
}

.opy-pay-btn__copy {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  min-width: 0;
  line-height: 1.15;
}

.opy-pay-btn__title {
  font-size: 22px;
  font-weight: 800;
  letter-spacing: 0.2px;
}

.opy-pay-btn__sub {
  margin-top: 4px;
  font-size: 14px;
  font-weight: 700;
  color: #5c3b00;
}

.opy-pay-btn__go {
  margin-left: auto;
  flex: 0 0 auto;
  padding: 8px 14px;
  border-radius: 999px;
  background: #00092d;
  color: #ffc200;
  font-size: 14px;
  font-weight: 800;
  letter-spacing: 0.3px;
}

@keyframes opy-pay-pulse {
  0%,
  100% {
    box-shadow:
      0 10px 28px rgba(255, 176, 0, 0.4),
      0 0 0 0 rgba(255, 194, 0, 0.45),
      inset 0 1px 0 rgba(255, 255, 255, 0.7);
  }
  50% {
    box-shadow:
      0 10px 28px rgba(255, 176, 0, 0.4),
      0 0 0 8px rgba(255, 194, 0, 0),
      inset 0 1px 0 rgba(255, 255, 255, 0.7);
  }
}

@keyframes opy-pay-shimmer {
  0%,
  55% {
    transform: translateX(-130%);
  }
  100% {
    transform: translateX(130%);
  }
}

@media (prefers-reduced-motion: reduce) {
  .opy-pay-btn,
  .opy-pay-btn__shine::before {
    animation: none;
  }
}

@media (max-width: 640px) {
  .opy-pay-btn {
    gap: 12px;
    padding: 14px;
  }

  .opy-pay-btn__title {
    font-size: 18px;
  }

  .opy-pay-btn__go {
    display: none;
  }
}
</style>
